import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  normal: boolean;
  isAutoGenerable: boolean;
  envioCorreoRecuperacion: boolean;
  email: string;
}

@Component({
  selector: 'app-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styles: []
})

export class ResetPasswordRequestComponent implements OnInit {

  @ViewChild('email', { static: false }) useremailInput: ElementRef;
  formEmail: FormGroup;
  value: string = "";

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<ResetPasswordRequestComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.formEmail = this.createFormGroupPass();
  }

  ngOnInit() {
  }

  createFormGroupPass() {
    return this.fb.group({
      email: ["",[Validators.required, Validators.email]]
    });
  }

  cancelar() {
    this.dialogRef.close('');
  }

  envioCorreo() {
    this.dialogRef.close(this.formEmail.value.email);
  }

}
